var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoArrowleft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03211 0.833956C9.23221 1.03546 9.337 1.29193 9.34646 1.60335C9.35592 1.91477 9.26023 2.17124 9.0594 2.37275L3.71109 7.75851L15.9085 7.75851C16.2178 7.75851 16.4772 7.86403 16.6867 8.07506C16.8963 8.28609 17.0007 8.54695 17 8.85764C17 9.16906 16.8952 9.43029 16.6856 9.64133C16.4761 9.85236 16.217 9.95751 15.9085 9.95678L3.71109 9.95678L9.0594 15.3425C9.2595 15.5441 9.35519 15.8005 9.34646 16.1119C9.33773 16.4234 9.23294 16.6798 9.03211 16.8813C8.832 17.0828 8.57732 17.1836 8.26807 17.1836C7.95881 17.1836 7.70413 17.0828 7.50402 16.8813L0.300178 9.62704C0.191028 9.53544 0.113532 9.42077 0.0676892 9.28301C0.0218461 9.14525 -0.000712156 9.00346 1.64383e-05 8.85764C1.64254e-05 8.71109 0.0225746 8.5737 0.0676891 8.44547C0.112804 8.31724 0.190301 8.19816 0.300178 8.08825L7.50402 0.833957C7.70413 0.632449 7.95881 0.531693 8.26806 0.531693C8.57732 0.531693 8.832 0.632449 9.03211 0.833956Z",
    fill: "#535353"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowleft);
export default __webpack_public_path__ + "static/media/ico-arrowleft.9c73b4be249d89962375e72d530e81c8.svg";
export { ForwardRef as ReactComponent };